// src/components/ProductsDetail/ProductDetailNav.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

// ✅ 방금 보내준 제품 리스트 import (경로만 프로젝트에 맞게 수정)
import {
  trafficSafetyProducts,
  guardrailProducts,
  facilitiesProducts,
  signageProducts,
} from '../../data/products'; // <-- 실제 위치로 바꿔줘

// 카테고리별로 리스트 매핑
const productMap = {
  'traffic-safety': trafficSafetyProducts,
  guardrail: guardrailProducts,
  facilities: facilitiesProducts,
  signage: signageProducts,
};

const NavWrapper = styled.div`
  max-width: 720px;
  margin: 80px auto 70px;
  padding-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  column-gap: 40px;

  @media (max-width: 640px) {
    column-gap: 24px;
    margin: 40px auto 30px;
  }
`;

const CircleButton = styled.button`
  width: 64px;
  height: 64px;
  border-radius: 999px;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: 700;
  background: ${({ disabled }) => (disabled ? '#e5e7eb' : '#005BAC')};
  color: ${({ disabled }) => (disabled ? '#9ca3af' : '#ffffff')};
  cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
  pointer-events: ${({ disabled }) => (disabled ? 'none' : 'auto')};
  transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;

  &:hover {
    ${({ disabled }) =>
      !disabled &&
      `
      transform: translateY(-1px);
    `}
  }

  @media (max-width: 640px) {
    width: 42px;
    height: 42px;
    font-size: 14px;
  }
`;

const ListButton = styled.button`
  min-width: 230px;
  height: 64px;
  padding: 18px 40px;
  border-radius: 999px;
  border: none;
  background: #f3f4f6;
  color: #111827;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  cursor: pointer;
  transition: transform 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;

  &:hover {
    background: #e5e7eb;
    transform: translateY(-1px);
  }

  @media (max-width: 640px) {
    min-width: 180px;
    height: 42px;
    padding: 12px 28px;
    font-size: 14px;
  }
`;

const ProductDetailNav = ({
  category,           // 'signage' | 'guardrail' | 'facilities' | 'traffic-safety'
  currentPath,        // 예: '/products/signage/seagull-sign'
  listPath,           // 예: '/products/signage' (없으면 category 기준으로 자동 생성)
  listLabel = '목록',
}) => {
  const navigate = useNavigate();

  const rawList = productMap[category] || [];
  const list = rawList.filter((p) => p.detailPath); // 혹시 detailPath 없는 경우 방어

  const index = list.findIndex((item) => item.detailPath === currentPath);
  if (index === -1) return null; // 현재 제품 못 찾으면 네비게이션 숨김

  const prev = index > 0 ? list[index - 1] : null;
  const next = index < list.length - 1 ? list[index + 1] : null;

  const goList = () => {
    if (listPath) {
      navigate(listPath);
    } else if (category) {
      navigate(`/products/${category}`);
    }
  };

  const goPrev = () => {
    if (prev?.detailPath) navigate(prev.detailPath);
  };

  const goNext = () => {
    if (next?.detailPath) navigate(next.detailPath);
  };

  return (
    <NavWrapper>
      <CircleButton
        type="button"
        onClick={goPrev}
        disabled={!prev}
        aria-label="이전 제품"
      >
        ←
      </CircleButton>

      <ListButton type="button" onClick={goList}>
        {listLabel}
      </ListButton>

      <CircleButton
        type="button"
        onClick={goNext}
        disabled={!next}
        aria-label="다음 제품"
      >
        →
      </CircleButton>
    </NavWrapper>
  );
};

export default ProductDetailNav;
